document.addEventListener("DOMContentLoaded", function () {
  console.log("running pdp spacer");
  if (window.location.pathname.includes("/products")) {
    var sizeProducts = document.querySelectorAll(".size-product");
    // Check if the current product template is "duracell-pdp-bundle"
    if (
      window.location.pathname.includes(
        "duracell-portable-power-station-300"
      ) ||
      window.location.pathname.includes(
        "duracell-portable-power-station-500"
      ) ||
      window.location.pathname.includes("duracell-portable-power-station-1000")
    ) {
      sizeProducts.forEach(function (element) {
        element.style.marginRight = "5px";
      });
    } else {
      // Apply a 20px right margin to elements with the class "size-product"
      sizeProducts.forEach(function (element) {
        element.style.marginRight = "15px";
      });
    }
  }

  // Wait for the DOM to load
window.addEventListener('DOMContentLoaded', function () {
    const stickyAtc = document.querySelector('.sticky-atc');
    const mainPdpContainer = document.querySelector('.dura-main-pdp-container');

    if (!stickyAtc || !mainPdpContainer) {
        console.error('Required elements are missing from the DOM.');
        return;
    }

    // Function to handle scroll and update element position
    function handleScroll() {
        const scrollThreshold = 100; // Change this value to adjust the scroll point

        if (window.scrollY > scrollThreshold) {
            if (!stickyAtc.classList.contains('active')) {
                mainPdpContainer.appendChild(stickyAtc);
                stickyAtc.classList.add('active');
            }
        } else {
            if (stickyAtc.classList.contains('active')) {
                stickyAtc.classList.remove('active');
            }
        }
    }

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);
});

});
